import { ChainId, NativeCurrency, Token } from '@uniswap/sdk-core'
import { nativeOnChain } from 'constants/tokens'
import { useMemo } from 'react'
import { DEFAULT_CHAIN_ID } from '../../constants/chains'

export default function useNativeCurrency(chainId: ChainId | null | undefined): NativeCurrency | Token {
  return useMemo(
    () =>
      chainId
        ? nativeOnChain(chainId)
        : // display mainnet when not connected
          nativeOnChain(DEFAULT_CHAIN_ID),
    [chainId]
  )
}
